export function SearchParamsToJSON(search) {
  const json = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
  return json;
}

export default { SearchParamsToJSON };
